import { useEffect } from 'react';

const useScript = (url: string, id: string, attributes: string[][]) => {
  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag['id'] = id;
    scriptTag.async = true;
    attributes.forEach((x) => {
      // console.log(x);
      scriptTag.setAttribute(x[0], x[1]);
    });

    document.body.appendChild(scriptTag);
    return () => {
      document.body.removeChild(scriptTag);
    };
  }, [url]);
};

export default useScript;
